/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { otc } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const OTC_TRADE = 'otc.trade';

queryClient.setMutationDefaults(OTC_TRADE, {
  mutationFn: otc.trade,
  onError: (error) => {
    handleError(error);
  },
});
